var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _setup.props.showDialog,
          expression: "props.showDialog",
        },
      ],
      staticClass: "dialog-container",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _setup.checkIfHideDialog.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-message-container" }, [
        _c("span", {
          class: [_setup.icon.close, "close-icon", "lf-icon__sm"],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _setup.hideDialog.apply(null, arguments)
            },
          },
        }),
        _c(
          "section",
          { staticClass: "cards-container" },
          [
            _c(_setup.ContactUsCardComponent),
            _c(_setup.ChatOnlineCardComponent, {
              on: { close: _setup.hideDialog },
            }),
            _c(_setup.HelpCenterCardComponent),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }